import React, { useState } from 'react';
import { IRegistroCircularizacao } from '../interfaces/ICircularizacao';
import { JUSTIFICATIVA_PADRAO_EXCLUSAO } from '../utils/justificativasPadrao';

interface Props {
  registro: IRegistroCircularizacao;
  categoriaLabel: string;
  excluindo: boolean;
  onCancelar: () => void;
  onConfirmar: (justificativa: string) => void;
}

const SUGESTOES_JUSTIFICATIVA = [
  'Circularização considerada desnecessária após avaliação do auditor.',
  'Empresa incluída em duplicidade na relação preliminar.',
  'Contraparte considerada fora do escopo de confirmação externa definido para o procedimento.',
  'Registro selecionado indevidamente, conforme análise complementar.',
];

// Seção 4.2 — "Confirmar Exclusão da Circularização". Justificativa da exclusão obrigatória;
// a exclusão é sempre lógica (RN-002 — ver CircularizacaoService.excluirEmpresa).
const ExcluirEmpresaModal: React.FC<Props> = ({ registro, categoriaLabel, excluindo, onCancelar, onConfirmar }) => {
  const [justificativa, setJustificativa] = useState(JUSTIFICATIVA_PADRAO_EXCLUSAO);
  const [tentouEnviar, setTentouEnviar] = useState(false);

  const confirmar = () => {
    setTentouEnviar(true);
    if (justificativa.trim().length === 0) return;
    onConfirmar(justificativa.trim());
  };

  return (
    <div className='circ-modal-backdrop' onMouseDown={(e) => e.target === e.currentTarget && onCancelar()}>
      <div className='circ-modal'>
        <div className='circ-modal-header'>
          <h4>Excluir da Circularização</h4>
          <button type='button' className='btn btn-sm btn-icon btn-light' aria-label='Fechar' onClick={onCancelar}>
            <i className='bi bi-x-lg' />
          </button>
        </div>
        <div className='circ-modal-body'>
          <dl className='circ-confirm-list' style={{ display: 'grid', gridTemplateColumns: '140px 1fr', gap: '8px 12px' }}>
            <dt className='text-muted' style={{ fontWeight: 700, fontSize: 12.5 }}>Nome da Empresa</dt>
            <dd style={{ margin: 0 }}>{registro.razaoSocialExibicao}</dd>
            <dt className='text-muted' style={{ fontWeight: 700, fontSize: 12.5 }}>Categoria</dt>
            <dd style={{ margin: 0 }}>{categoriaLabel}</dd>
            <dt className='text-muted' style={{ fontWeight: 700, fontSize: 12.5 }}>Justificativa Original</dt>
            <dd style={{ margin: 0 }}>{registro.justificativaOriginal}</dd>
          </dl>

          <div className='circ-form-group mt-3'>
            <label className='circ-campo-obrigatorio'>Justificativa da Exclusão</label>
            <textarea
              className='circ-form-control'
              rows={3}
              value={justificativa}
              onChange={(e) => setJustificativa(e.target.value)}
              placeholder='Informe o motivo da exclusão...'
            />
            {tentouEnviar && justificativa.trim().length === 0 && (
              <div className='text-danger mt-1' style={{ fontSize: 12 }}>
                A justificativa da exclusão é obrigatória.
              </div>
            )}
            <div className='mt-2 d-flex flex-wrap gap-1'>
              {SUGESTOES_JUSTIFICATIVA.map((sugestao) => (
                <button
                  key={sugestao}
                  type='button'
                  className='badge badge-light-secondary border-0'
                  style={{ cursor: 'pointer' }}
                  onClick={() => setJustificativa(sugestao)}
                >
                  {sugestao}
                </button>
              ))}
            </div>
          </div>
        </div>
        <div className='circ-modal-footer'>
          <button type='button' className='btn btn-sm btn-light' disabled={excluindo} onClick={onCancelar}>
            Cancelar
          </button>
          <button type='button' className='btn btn-sm btn-danger' disabled={excluindo} onClick={confirmar}>
            {excluindo && <span className='spinner-border spinner-border-sm me-1' />}
            Confirmar Exclusão
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExcluirEmpresaModal;
